module.exports = __webpack_public_path__ + "img/stripe-background.c17d1a04.png";